import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { PersistState } from "../redux/reducers/PersistSlice";
import { useAppSelector } from "../redux/hooks";

type Props = {
  messageKey: string;
  page: string;
};
const ClickToCall = (props: Props) => {
  const { t, i18n } = useTranslation();
  const messageString = t(props.messageKey);
  const numberPattern = /(\+[\d]{2}-[\d]{10})/g;
  const userSelectedLanguage: any = useAppSelector(PersistState);

  const handleClickOnNumber = (messageData: string) => {
    const messageParts = messageData.split(numberPattern);
    return messageParts.map((messageItem, index) => {
      if (numberPattern.test(messageItem)) {
        return (
          <a
            href={`tel:${messageItem}`}
            key={index}
            className={
              userSelectedLanguage?.language === "en" ||
              userSelectedLanguage?.language === "hi" ||
              props.page === "404"
                ? "clickToCallLink"
                : ""
            }
          >
            {messageItem}
          </a>
        );
      } else {
        return <span key={index}>{messageItem}</span>;
      }
    });
  };
  return <div>{handleClickOnNumber(messageString)}</div>;
};

export default ClickToCall;
